import React from 'react';

export const Tick: React.FC<React.SVGProps<SVGSVGElement>> = ({ width, height, color }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width || '1em'} height={height || '1em'} viewBox="0 0 128 128">
        <path fill={color || 'currentColor'} d="M45.2,97.9l-1.2,1c-3.4,2.8-8.5,2.3-11.3-1.1L14.8,76.2c-2.8-3.4-2.3-8.5,1.1-11.3l1.2-1c3.4-2.8,8.5-2.3,11.3,1.1l17.9,21.6C49.1,90,48.6,95.1,45.2,97.9z" />
        <path fill={color || 'currentColor'} d="M32.9,97.7l-1-1.2c-2.8-3.4-2.3-8.5,1.1-11.3l67.9-56.1c3.4-2.8,8.5-2.3,11.3,1.1l1,1.2c2.8,3.4,2.3,8.5-1.1,11.3L44.2,98.8C40.8,101.6,35.7,101.1,32.9,97.7z" />
    </svg>
);
